import { useContext, useEffect } from 'react';

import { FilterValue, PillFilters } from 'features/common-elements';
import {
  filtersToQueryFilters,
  searchQueryToFilterValues,
  filterValuesToSearchQuery,
} from 'features/common-elements';
import {
  marketplaceFiltersConfig,
  abbrToFilterKey,
  filterKeyToAbbr,
} from 'features/OnMarket/marketplace.config';
import { MarketplaceTable } from 'features/OnMarket/MarketplaceTable';
import { useMarketPlaceListings_gql } from 'features/OnMarket/useMarketPlaceListings_gql';
import { useSearchParams } from 'react-router-dom';

import { ListingField, ListingSort, SortDirection } from '../../../__generated__/globalTypes';
import * as navigation from '../../../app-level/navigation';
import { DataContext, DataContextActionType } from '../../../context/DataContext';

const MarketHome = () => {
  const [search, setSearch] = useSearchParams();
  const { dispatch } = useContext(DataContext);
  const searchFiltersStr = search.get('filters');
  const currentFilters = searchFiltersStr
    ? searchQueryToFilterValues(searchFiltersStr, abbrToFilterKey)
    : [];

  const queryFilters = filtersToQueryFilters<typeof marketplaceFiltersConfig>(
    currentFilters,
    marketplaceFiltersConfig,
  );

  const [marketHomeSorting, setMarketHomeSortingSorting] =
    navigation.useSortingHelper<ListingField>();

  // const [selectedPools, setSelectedPools] = useState<RowSelectionState>({});

  const sortVariable: ListingSort = marketHomeSorting?.length
    ? {
        sort_field: marketHomeSorting[0].id,
        sort_direction: marketHomeSorting[0].desc ? SortDirection.desc : SortDirection.asc,
      }
    : {};

  const { listings, loading } = useMarketPlaceListings_gql(queryFilters, sortVariable);

  useEffect(() => {
    dispatch({
      type: DataContextActionType.SET_LOADING,
      payload: loading,
    });
  }, [loading]);

  function setFilters(filters: FilterValue<typeof marketplaceFiltersConfig>[]) {
    const newFilters = filterValuesToSearchQuery(filters, filterKeyToAbbr);
    const newSearch = new URLSearchParams();
    newSearch.set('filters', newFilters);
    setSearch(newSearch);
  }

  return (
    <>
      <div className="p-3" style={{ gridArea: 'summery' }}>
        <PillFilters
          filtersConfig={marketplaceFiltersConfig}
          currentFilters={currentFilters}
          setCurrentFilters={setFilters}
        />
      </div>
      <div className="min-w-[14px]" style={{ gridArea: 'sidebar' }}></div>
      <div className="page">
        <MarketplaceTable
          data={listings}
          sorting={{
            state: marketHomeSorting,
            onSortingChanged: setMarketHomeSortingSorting,
          }}
          // selection={{ selected: selectedPools, onSelectionChange: setSelectedPools }}
        />
      </div>
    </>
  );
};

export default MarketHome;
